module.exports = __webpack_public_path__ + "img/015be4d.jpg";